import { GET_CARD_URL } from "../../config";
import Axios from "axios";

export async function getCardByToken(sessionToken) {
  const response = await Axios.get(GET_CARD_URL(sessionToken));
  return response.data;
}
